import { TypedAction } from '@ngrx/store/src/models'

export const dispatchErrorAction = (
  actionFactory,
  error: Error
): TypedAction<string> => {
  console.error(error)
  return actionFactory()
}
